import * as React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from '@cian/ui-kit';

import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import { SearchSuggestAdornment } from '../../../../components/SearchSuggest';
import { selectSuggestionsLoading } from '../../../../selectors/suggestions';
import { MIN_CHARS_TO_DISPLAY_SUGGEST } from '../../constants';

interface IRightAdornmentContainerProps {
  suggestionsLength: number;
  valueLength: number;
  onClearClick: () => void;
}

export const RightAdornmentContainer: React.FC<IRightAdornmentContainerProps> = ({
  suggestionsLength,
  valueLength,
  onClearClick,
}) => {
  const isLoading = useSelector(selectSuggestionsLoading);

  if (isLoading) {
    return <SearchSuggestAdornment icon={<Spinner size={24} data-testid="SuggestSpinner" />} />;
  }

  if (suggestionsLength > 0 && MIN_CHARS_TO_DISPLAY_SUGGEST <= valueLength) {
    return (
      <SearchSuggestAdornment
        icon={<IconActionClose16 color="icon-main-default" data-testid="SuggestClear" />}
        onClick={onClearClick}
      />
    );
  }

  return null;
};
